import { Injectable } from '@angular/core';
import { HttpRequestModel, HttpService } from '../httpservice/http.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class TaxStatusService {
  HttpRequestModel: HttpRequestModel = new HttpRequestModel();

  constructor(private httpService: HttpService) {}

  //Request to get all tax status
  getTaxStatus(showLoader = false, hideLoader = false): Observable<any> {
    this.HttpRequestModel.reset();
    this.HttpRequestModel.url = 'tax_status';
    this.HttpRequestModel.method = 'GET';
    this.HttpRequestModel.body = '';

    return this.httpService.init(this.HttpRequestModel, showLoader, hideLoader).pipe(map(response => response));
  }
}
